export const ENGAGEMENT_DETAILS_MESSAGE = 'ENGAGEMENT_DETAILS_MESSAGE';